<script setup lang="ts">
import { useUserStore } from '@core/stores/user'
import PlayersRatingCard from '@/views/dashboards/PlayersRatingCard.vue'
import PlayerLastGamesEffectiveness from '@/views/dashboards/PlayerLastGamesEffectiveness.vue'
import PlayerCompetenceRadarCard from '@/views/dashboards/PlayerCompetenceRadarCard.vue'
import PlayerSummary from '@/views/dashboards/PlayerSummary.vue'
import OrganizationSubscriptionCard from '@/views/dashboards/OrganizationSubscriptionCard.vue'

const { t } = useI18n()

definePage({
  meta: {
    action: 'read',
    subject: 'dashboard-manager',
  },
})

const userStore = useUserStore()
</script>

<template>
  <div>
    <!-- 👉 Subscription banner -->
    <VRow class="pt-6">
      <VCol cols="12">
        <OrganizationSubscriptionCard />
      </VCol>
    </VRow>

    <VRow class="pt-6">
      <!-- 👉 Welcome -->
      <VCol
        cols="12"
        md="8"
        class="match-height"
      >
        <div class="pe-3">
          <h5 class="text-h5 mb-2">
            {{ t('dashboards.player.summary.welcome') }}, <span class="text-h4"> {{ userStore.fullName.split(' ')[0] }} 👋🏻 </span>
          </h5>

          <div
            class="text-wrap text-body-1"
            style="max-inline-size: 360px;"
          >
            {{ t('dashboards.player.summary.progress') }}:
          </div>

          <div class="d-flex justify-space-between flex-wrap gap-4 flex-column flex-sm-row mt-10">
            <PlayerSummary />
          </div>
        </div>
      </VCol>

      <!-- 👉 Effectiveness -->
      <VCol
        cols="12"
        md="4"
      >
        <PlayerLastGamesEffectiveness />
      </VCol>
    </VRow>

    <VRow class="match-height">
      <!-- 👉 Topics you are interested in -->
      <VCol
        cols="12"
        md="8"
      >
        <PlayerCompetenceRadarCard
          :user-data="null"
          for-manager
        />
      </VCol>
      <VCol
        cols="12"
        md="4"
      >
        <PlayersRatingCard />
      </VCol>
    </VRow>
  </div>
</template>

<style lang="scss">
@use "@core-scss/template/libs/apex-chart.scss";
</style>
